import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import BackLink, { BackLinkProps } from '../BackLink/BackLink';
import Header from '../Header';
import Typography from '../Typography';
import './style.scss';

interface DetailLayoutProps extends Partial<BackLinkProps> {
  title: ITranslations;
  description?: ITranslations;
}

const DetailLayout: React.FC<DetailLayoutProps> = ({
  backAction,
  backLabel,
  title,
  description,
  children,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hideBreadcrumbs = !!queryParams.get('redirectUrl');

  return (
    <>
      <Header hideBreadcrumbs={hideBreadcrumbs} />
      <div className="u-wrapper ckp-o-detail-layout">
        <Helmet>
          <title>{translate(title)}</title>
          {description && <meta name="description" content={translate(description)} />}
        </Helmet>

        <div className="u-container u-margin-top-xl u-margin-bottom">
          {backAction && backLabel && <BackLink backAction={backAction} backLabel={backLabel} />}

          <main id="main-content" className="row" role="main">
            <div className="col-xs-12">
              <header>
                {title && (
                  <Typography variant="h1" as="h2" classNames="u-margin-bottom-xs">
                    {translate(title)}
                  </Typography>
                )}

                {description && (
                  <Typography classNames="u-margin-bottom">{translate(description)}</Typography>
                )}
              </header>

              {children}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default DetailLayout;
